import { BLACK, TRANSPARENT } from '../colors';
var loaderConfig = {
  theme: 'light',
  labelPosition: 'right',
  size: 'md',
  color: BLACK,
  bgColor: TRANSPARENT,
  config: {
    sm: {
      loaderSize: 14,
      padding: 'SPACING_5'
    },
    md: {
      loaderSize: 22,
      padding: 'SPACING_9'
    },
    lg: {
      loaderSize: 32,
      padding: 'SPACING_12'
    },
    xl: {
      loaderSize: 42,
      padding: 'SPACING_15'
    },
    xxl: {
      loaderSize: 72,
      padding: 'SPACING_24'
    }
  }
};
export default {
  light: loaderConfig,
  dark: loaderConfig,
  white: loaderConfig
};